/*
Replace
technique with your resource Name :) Take care about different writings!
/!\ Technique technique Techniques techniques /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const techniqueSlice = createSlice({
  name: "techniques",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listTechniques,
  show: showTechnique,
  create: createTechnique,
  update: updateTechnique,
} = techniqueSlice.actions;

export const actions = techniqueSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const techniques = (state) =>
  state.techniques.idsList.map((id) => state.techniques.dictionary[id]);
export const technique = (state) =>
  state.techniques.showId &&
  state.techniques.dictionary[state.techniques.showId];
export const techniqueAttributes = (state) => technique(state)?.attributes;
export const techniqueRelationships = (state) =>
  technique(state)?.relationships;
export const techniqueId = (state) => state.techniques.showId;

export const getTechnique = createSelector(
  (state) => state.techniques.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getTechniqueAttributes = createSelector(
  (state) => state.techniques.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getTechniqueRelationships = createSelector(
  (state) => state.techniques.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getTechniques = createSelector(
  (state) => state.techniques.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default techniqueSlice.reducer;
